import type { FormatInfo } from "../qr-decoder/types";

export const FORMAT_INFO_DECODE_TABLE = new Map<number, FormatInfo>();
